import { render, staticRenderFns } from "./ReportLetter.vue?vue&type=template&id=167bd696"
import script from "./ReportLetter.vue?vue&type=script&lang=js"
export * from "./ReportLetter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('167bd696')) {
      api.createRecord('167bd696', component.options)
    } else {
      api.reload('167bd696', component.options)
    }
    module.hot.accept("./ReportLetter.vue?vue&type=template&id=167bd696", function () {
      api.rerender('167bd696', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/back/TemplateMaintain/ReportLetter.vue"
export default component.exports